/* eslint-disable no-unused-vars */
import axios from "../../axios";

const urlListStudent = "/email-list-students";
const urlListStudentByTemp = "/list-user-email-tempalte";
const state = {
  workflows: [],
  workflowDetail: {},
  pagination: {
    current_page: 1,
    per_page: 10,
    total: 0,
  },
  listUserByTemplate: [],
};

const actions = {
  /**
   * Get list students
   * @param commit
   * @param query
   * @returns {Promise<void>}
   */
  async getLists({ commit }, query) {
    try {
      const response = await axios.get(
        `${urlListStudent}?${new URLSearchParams(query)}`,
      );
      if (response.status === 200) {
        commit("SET_LIST_WORKFLOW", response.data.data);
      }
    } catch (e) {
      console.log("exception: ", e);
    }
  },
  /**
   * Detail
   * @param commit
   * @param id
   * @returns {Promise<{}|*>}
   */
  async detail({ commit }, id) {
    try {
      const response = await axios.get(
        `${urlListStudent}/${id}?include=template`,
      );
      if (response.status === 200) {
        return commit("SET_WORKFLOW_DETAIL", response.data.data);
      }
      return {};
    } catch (e) {
      console.log("exception: ", e);
      return {};
    }
  },

  /**
   * Create
   * @param commit
   * @param payload
   * @returns {Promise<AxiosResponse<any>>}
   */
  async create({ commit }, payload) {
    return await axios.post(urlListStudent, payload);
  },

  /**
   * Update
   * @param commit
   * @param id
   * @param payload
   * @returns {Promise<AxiosResponse<any>>}
   */
  async update({ commit }, { id, payload }) {
    return await axios.put(`${urlListStudent}/${id}`, payload);
  },

  /**
   * Delete
   * @param commit
   * @param id
   * @returns {Promise<AxiosResponse<any>>}
   */
  async delete({ commit }, id) {
    return await axios.delete(`${urlListStudent}/${id}`);
  },
  /**
   * Get list user by email template
   */
  async getListUser({ commit }, query) {
    try {
      const response = await axios.get(
        `${urlListStudentByTemp}/${query.templId}`,
      );
      if (response.status === 200) {
        console.log("response.data.data", response.data.data);
        commit("SET_LIST_USERS", response.data.data);
      }
    } catch (e) {
      console.log("exception: ", e);
    }
  },

  /**
   * set current page
   * @param commit
   * @param data
   */
  setCurrentPage({ commit }, data) {
    commit("SET_CURRENT_PAGE", data);
  },

  /**
   * set per page
   * @param commit
   * @param data
   */
  setPerPage({ commit }, data) {
    commit("SET_PER_PAGE", data);
  },
};

const mutations = {
  // EDIT_DATA (state, itemId) {
  //   state.students.map(item => {
  //     item.isOpen = false
  //     return item
  //   })
  //   const userIndex = state.students.findIndex((u) => u.id === itemId)
  //   if (userIndex >= 0) {
  //     state.students[userIndex].isOpen = true
  //   }

  // },
  SET_WORKFLOW_DETAIL(state, data) {
    state.workflowDetail = data;
  },
  SET_LIST_WORKFLOW(state, data) {
    data.items.map((item) => {
      const filters = JSON.parse(item.filters);
      let numberContact = 0;
      Object.values(filters).map((item) => {
        numberContact += parseInt(item);
      });
      item.numberContact = numberContact;
      return item;
    });
    state.workflows = data.items;

    state.pagination = data.pagination;
  },
  SET_CURRENT_PAGE(state, data) {
    state.pagination.current_page = data;
  },
  SET_PER_PAGE(state, data) {
    state.pagination.per_page = data;
  },
  SET_LIST_USERS(state, data) {
    state.listUserByTemplate = data;
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
